import { Component } from '@angular/core';

@Component({
  selector: 'app-feetest',
  templateUrl: './feetest.component.html',
  styleUrls: ['./feetest.component.css']
})
export class FeetestComponent {

  constructor() { }


}
